// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__KPbIT","buttons":"PendingPaymentAlert_buttons__2l1bX"};